<template>
    <div>
        <v-stepper v-model="e1" dark>
            <v-stepper-header class="mb-5">
                <v-stepper-step class="ml-5" :complete="e1 > 1" step="1">User Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step class="mr-5" :complete="e1 > 2" step="2">User Permissions</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                        <v-form class="mb-5" height="200px">
                            <v-container>
                                <v-layout row wrap>
                                    <v-flex xs6 sm3>          
                                        <v-text-field class="" label="First Name" v-model="firstName" box></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm3>
                                        <v-text-field label="Last Name" v-model="lastName" box></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm3>
                                        <v-text-field label="Mobile" type="number" v-model="number" box></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm3>          
                                        <v-text-field box v-model="email" label="Email" type="email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm3>          
                                        <v-text-field box v-model="password" label="Password" type="password">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    <v-btn color="primary" @click="e1 = 2"> 
                        Continue
                    </v-btn>
                </v-stepper-content>
                <v-stepper-content step="2">
                        <v-form class="mb-5" height="200px">
                            <v-container>
                                <v-layout row wrap>
                                    <v-flex xs6 sm3>          
                                        <v-text-field class="" label="Job Title" v-model="userJobTitle" box></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm3>          
                                        <v-select box :items="roles" v-model="role" label="Permission Role">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    <v-btn color="success" @click="saveAdminUser"> 
                        Save
                    </v-btn>
                    <v-btn flat @click="e1 = 1">Back</v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
</template>
<script>
import db from '../firebase/init.js'
export default {
    name: 'AddAdminUser',
    props: ['dialog'],
    data(){
        return {
            roles: ['Super', 'AM', 'View'],
            firstName: '',
            lastName: '',
            number: null,
            email: '',
            password: '',
            role: '',
            userJobTitle: '',
            e1: 1,
            uid: ''
        }
    },
    methods: {
        saveAdminUser(){

            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
            .catch(function(error){
                var errorCode = error.code
                var errorMessage = error.message
                console.log(errorMessage)
            })

            db.collection('admin-users').doc(this.email).set({
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.number,
                role: this.role,
                position: this.userJobTitle,
            }).then(() => {
                this.firstName = ''
                this.lastName = ''
                this.number = null
                this.email = ''
                this.role = ''
                this.userJobTitle = ''
                this.e1 = 1
                this.$emit('closed')  
            }).catch(err => {
                console.log(err)
            })
        }
   }
}
</script>
<style>
</style>
